<h2><span i18n="@@titleInstallerSettings">Installer Settings</span>&nbsp;<span i18n="@@Charger">Charger</span> {{ chargerId }}</h2>

@if (chargerPropertiesLoaded()) {
	@if (chargerProperties().length > 0) {
		<div class="card-container">
			<mat-card class="mat-elevation-z5">
				<mat-card-content>
					<mat-list>
						@for (property of chargerProperties(); track property.name) {
							<mat-list-item>
								<div class="item-block">
									<div class="line-top">{{ property.name }}</div>
									<div class="title-bottom">
										<app-property
											[id]="property.id"
											[type]="property.type"
											[value]="property.valueWithMetadata"
											[saveCallback]="saveCallback"
										/>
									</div>
								</div>
							</mat-list-item>
						}
					</mat-list>
				</mat-card-content>
			</mat-card>
		</div>
	} @else {
		<span i18n="@@NoSettingsAvailable">No settings available!</span>
	}
} @else {
	<mat-spinner />
}
